<template>
  <base-carousel
    v-if="filteredCards.length"
    :items="filteredCards"
    :breakpoints="breakpoints"
    tracking-component-name="deal_carousel"
    class="deal-carousel"
    stretch-to-edge
  >
    <template #header>
      <header class="deal-carousel-header">
        <h2 v-if="title" class="deal-carousel-header__title">
          {{ title }}
        </h2>
        <sc-rich-text
          v-track-rich-text-links="'deal_carousel'"
          class="deal-carousel-header__description"
          :field="{ value: description }"
        />
      </header>
    </template>
    <template #default="{ item }">
      <deal-carousel-card :card="item" />
    </template>
  </base-carousel>
</template>

<script setup lang="ts">
import type { DealCarouselProps, DealCard } from './types';
import { RichText as ScRichText } from '@sitecore-jss/sitecore-jss-vue';
import { computed } from 'vue';
import vTrackRichTextLinks from '../../../directives/vTrackRichTextLinks';
import DealCarouselCard from './DealCarouselCard/DealCarouselCard.vue';
import BaseCarousel from '@/components/2_elements/BaseCarousel/BaseCarousel.vue';
import { normalizePx } from '../../../utils/scalingUtils';
import type { SwiperOptions } from 'swiper/types';

const props = withDefaults(defineProps<DealCarouselProps>(), {
  title: '',
  description: '',
});

const breakpoints: SwiperOptions['breakpoints'] = {
  0: {
    enabled: true,
    slidesPerView: 1.5,
  },
  [normalizePx(768) ?? 768]: {
    enabled: true,
    slidesPerView: 2.5,
  },
  [normalizePx(1024) ?? 1024]: {
    enabled: true,
    slidesPerView: 4.5,
  },
};

const filteredCards = computed(() => {
  if (!props.cards?.value) return [];
  const filtered = props.cards.value.filter((card: DealCard) => card.showInCarousel);
  return filtered.sort((a: DealCard, b: DealCard) => (a.order ?? 0) - (b.order ?? 0));
});
</script>

<style lang="scss">
@import './scss/DealCarousel.scss';
</style>
